<template>
    <div class="scene">
        <img :src="loading" oncontextmenu="return false;"  ondragstart="return false;" alt="">
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: require('@/assets/tic/loading.gif')
        }
    },
}
</script>
<style scoped>
.scene {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #222428;
    user-select: none;
    z-index: 999;
}
.scene img {
    width: 300px;
}

</style>


// WEBPACK FOOTER //
// src/components/live-loading.vue